import { render, staticRenderFns } from "./DuplicateScreen.vue?vue&type=template&id=c9c3a598&scoped=true&"
import script from "./DuplicateScreen.vue?vue&type=script&scoped=true&lang=js&"
export * from "./DuplicateScreen.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./DuplicateScreen.vue?vue&type=style&index=0&id=c9c3a598&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9c3a598",
  null
  
)

export default component.exports